import moment from 'moment';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { mapBetHistoryTicket } from './ticketMapper';

export const loadBetHistory = async (start, end) => {
  const data = await swarmRequest({
    where: {
      with_pool_bets: false,
      from_date: moment(start).startOf('D').unix(),
      to_date: moment(end).endOf('D').unix(),
    },
    product: 'Sport',
  }, 'bet_history');

  if (data?.bets) {
    const events = data.bets.flatMap((item) => item.events);

    const matches = await swarmRequest(
      {
        match_id_list: events.map((game) => game.match_display_id),
      },
      'get_match_scores',
    );

    if (matches.details) {
      const scoresInfo = matches?.details?.reduce((acc, item) => {
        acc[item.match_id] = item.score;
        return acc;
      }, {});

      return data.bets?.map(mapBetHistoryTicket(scoresInfo));
    }
  }

  return data?.bets?.map(mapBetHistoryTicket());
};
